var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "vehicle-stock-list", attrs: { id: "result-search-page" } },
    [
      _c("div", { staticClass: "container full-width" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "search-result-top" }, [
            _c("div", { staticClass: "top" }, [
              _c("div", { staticClass: "left" }, [
                _c(
                  "h2",
                  [
                    _vm._t("title", function() {
                      return [_vm._v(" SBL Stock")]
                    })
                  ],
                  2
                )
              ])
            ]),
            _vm._v(" "),
            _vm.disableHead !== true
              ? _c("div", { staticClass: "bottom space-between" }, [
                  _c("div", { staticClass: "left" }, [
                    _c("span", { staticClass: "showing" }, [
                      _c("strong", [_vm._v("Showing")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.from))]),
                      _vm._v("-"),
                      _c("span", [_vm._v(_vm._s(_vm.to))]),
                      _vm._v(" of "),
                      _c("span", [_vm._v(_vm._s(_vm.total))]),
                      _vm._v(
                        "\n                            results\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "view-type-selection" }, [
                      _c(
                        "label",
                        {
                          class: _vm.viewType === "grid" ? "active" : "",
                          attrs: { for: "view-grid" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.viewType,
                                expression: "viewType"
                              }
                            ],
                            attrs: {
                              id: "view-grid",
                              type: "radio",
                              value: "grid"
                            },
                            domProps: { checked: _vm._q(_vm.viewType, "grid") },
                            on: {
                              change: [
                                function($event) {
                                  _vm.viewType = "grid"
                                },
                                _vm.rowColours
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("icon", { attrs: { icon: " fa-lg fa-th" } })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          class: _vm.viewType === "list" ? "active" : "",
                          attrs: { for: "view-list" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.viewType,
                                expression: "viewType"
                              }
                            ],
                            attrs: {
                              id: "view-list",
                              type: "radio",
                              value: "list"
                            },
                            domProps: { checked: _vm._q(_vm.viewType, "list") },
                            on: {
                              change: [
                                function($event) {
                                  _vm.viewType = "list"
                                },
                                _vm.rowColours
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c("icon", { attrs: { icon: " fa-lg fa-list" } })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.showRepFilter
                      ? _c(
                          "div",
                          [
                            _c("user-selector", {
                              staticClass: "form-control",
                              attrs: {
                                includeReps: true,
                                includeDealers: false,
                                includeAdmins: false,
                                nullLabel: _vm.userListNullLabel
                                  ? _vm.userListNullLabel
                                  : "-",
                                "filter-by-shared-sales-reps": _vm.filterBySharedSalesReps
                                  ? true
                                  : false
                              },
                              on: { change: _vm.onChange },
                              model: {
                                value: _vm.userFilter,
                                callback: function($$v) {
                                  _vm.userFilter = $$v
                                },
                                expression: "userFilter"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "select-all" },
                      [
                        _c(
                          "el-select",
                          {
                            on: { change: _vm.onMakeChange },
                            model: {
                              value: _vm.makeFilter,
                              callback: function($$v) {
                                _vm.makeFilter = $$v
                              },
                              expression: "makeFilter"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: null, label: "Filter by make" }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.makes, function(item) {
                              return _c("el-option", {
                                key: item.make,
                                attrs: { label: item.make, value: item.make }
                              })
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.makeFilter
                      ? _c(
                          "div",
                          { staticClass: "select-all" },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { loading: _vm.modelsLoading },
                                on: { change: _vm.onChange },
                                model: {
                                  value: _vm.modelFilter,
                                  callback: function($$v) {
                                    _vm.modelFilter = $$v
                                  },
                                  expression: "modelFilter"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    value: null,
                                    label: "Filter by model"
                                  }
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.models, function(item) {
                                  return _c("el-option", {
                                    key: item.model,
                                    attrs: {
                                      label: item.model,
                                      value: item.model
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-all" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search"
                          }
                        ],
                        ref: "filter_stockid",
                        attrs: {
                          id: "filter-stockid",
                          type: "text",
                          placeholder: "Stock ID / Chassis | Lot #",
                          title:
                            "Search multiple by separating by comma or space"
                        },
                        domProps: { value: _vm.search },
                        on: {
                          keyup: _vm.onChange,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.search = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "right" }, [
                    _vm.$userIsAdmin()
                      ? _c(
                          "div",
                          { staticClass: "text-right" },
                          [
                            !_vm.hideAddNew
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn",
                                    attrs: { href: "/vehicle-stock/create" }
                                  },
                                  [_vm._v("Add new vehicle")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn",
                                attrs: { href: _vm.csvLink, target: "_blank" }
                              },
                              [_vm._v("CSV")]
                            ),
                            _vm._v(" "),
                            _vm._t("right_buttons")
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-table" }, [
            _vm.viewType === "list"
              ? _c(
                  "div",
                  { staticClass: "list-table table-responsive" },
                  [
                    _c("b-table", {
                      staticClass: "list-table",
                      attrs: {
                        "sort-by": _vm.sort_by,
                        "sort-desc": _vm.sort_desc,
                        fields: _vm.fields,
                        items: _vm.vehicle_stocks,
                        "no-local-sorting": true,
                        "show-empty": "",
                        "tbody-tr-class": _vm.tbodyTrClass,
                        "primary-key": "id"
                      },
                      on: {
                        "update:sortBy": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sort-by": function($event) {
                          _vm.sort_by = $event
                        },
                        "update:sortDesc": function($event) {
                          _vm.sort_desc = $event
                        },
                        "update:sort-desc": function($event) {
                          _vm.sort_desc = $event
                        },
                        "sort-changed": _vm.onChange
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "empty",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                            No data is available...\n                        "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(vehicle)",
                            fn: function(data) {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.$laravelRoute(
                                        "vehicle-stock.show",
                                        data.item.id
                                      )
                                    }
                                  },
                                  [
                                    data.item.front_image_url
                                      ? _c("img", {
                                          attrs: {
                                            src: data.item.front_image_url,
                                            alt: "Front",
                                            height: "50"
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(co2_text)",
                            fn: function(data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class:
                                      data.item.co2_text[0] === "-"
                                        ? "text-danger"
                                        : "text-success"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          data.item.co2_text.replace("-", "")
                                        ) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(stock_id)",
                            fn: function(data) {
                              return [
                                data.item.stock_id
                                  ? [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(data.item.stock_id) +
                                          "\n                            "
                                      )
                                    ]
                                  : data.item.sold &&
                                    data.item.sold.heiwa_stock_id
                                  ? [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            data.item.sold.heiwa_stock_id
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(data.item.green_tree_sync_id) +
                                          "\n                            "
                                      )
                                    ]
                              ]
                            }
                          },
                          {
                            key: "cell(actions)",
                            fn: function(data) {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.$laravelRoute(
                                        "vehicle-stock.edit",
                                        data.item.id
                                      )
                                    }
                                  },
                                  [_vm._v("Edit")]
                                ),
                                _vm._v(" |\n                            "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.$laravelRoute(
                                        "vehicle-stock.show",
                                        data.item.id
                                      )
                                    }
                                  },
                                  [_vm._v("View")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3529036936
                      )
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "container-results",
                    attrs: { id: "container-results" }
                  },
                  [
                    _vm.vehicle_stocks.length === 0
                      ? _c("div", [
                          _vm._v(
                            "\n                        No vehicles\n                    "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.vehicle_stocks, function(vehicle) {
                      return [
                        _c(
                          "div",
                          { staticClass: "single-result-search is-vehicle" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "container-single-result-search",
                                on: {
                                  click: function($event) {
                                    return _vm.selectVehicle(vehicle, $event)
                                  }
                                }
                              },
                              [
                                vehicle.buy_now
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "vehicle-banner now-sold"
                                      },
                                      [_vm._v("Now Sold")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "stockid" },
                                  [
                                    _vm.enableSelection
                                      ? _c(
                                          "span",
                                          { staticClass: "checkbox" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.selected_ids,
                                                  expression: "selected_ids"
                                                }
                                              ],
                                              attrs: {
                                                type: "checkbox",
                                                id:
                                                  "select-vehicle-" + vehicle.id
                                              },
                                              domProps: {
                                                value: vehicle.id,
                                                checked: Array.isArray(
                                                  _vm.selected_ids
                                                )
                                                  ? _vm._i(
                                                      _vm.selected_ids,
                                                      vehicle.id
                                                    ) > -1
                                                  : _vm.selected_ids
                                              },
                                              on: {
                                                change: function($event) {
                                                  var $$a = _vm.selected_ids,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = vehicle.id,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.selected_ids = $$a.concat(
                                                          [$$v]
                                                        ))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.selected_ids = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.selected_ids = $$c
                                                  }
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("label", {
                                              attrs: {
                                                for:
                                                  "select-vehicle-" + vehicle.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.selectVehicle(
                                                    vehicle,
                                                    $event
                                                  )
                                                }
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    vehicle.stock_id
                                      ? [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(vehicle.stock_id) +
                                              "\n                                    "
                                          )
                                        ]
                                      : vehicle.sold &&
                                        vehicle.sold.heiwa_stock_id
                                      ? [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                vehicle.sold.heiwa_stock_id
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                vehicle.green_tree_sync_id
                                              ) +
                                              "\n                                    "
                                          )
                                        ],
                                    _vm._v(" "),
                                    _vm.showQuickImages
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "vehicle-hover-images"
                                          },
                                          [
                                            _c("vehicle-hover-images", {
                                              attrs: {
                                                vehicle: vehicle,
                                                letters_only: true
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$userIsAdmin()
                                      ? _c(
                                          "div",
                                          { staticClass: "unsold-info" },
                                          [
                                            (vehicle.is_unsold &&
                                              vehicle.public_date) ||
                                            _vm.getter === "global"
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "top-start",
                                                      effect: "light",
                                                      content: _vm.publicDateToolTip(
                                                        vehicle
                                                      )
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "b-badge",
                                                      {
                                                        attrs: {
                                                          pill: "",
                                                          variant:
                                                            vehicle.user_region_price ||
                                                            _vm.getter ===
                                                              "global"
                                                              ? "light"
                                                              : "danger"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              _vm.daysUntil(
                                                                vehicle
                                                              )
                                                            ) +
                                                            "\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            vehicle.is_unsold ||
                                            _vm.getter === "global"
                                              ? _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top-start",
                                                      title: "Rep Note",
                                                      width: "200",
                                                      trigger: "hover",
                                                      disabled: !vehicle.rep_note,
                                                      content: vehicle.rep_note
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "note-icon fa fa-fw fa-lg",
                                                      class: {
                                                        "fa-file-text-o":
                                                          vehicle.rep_note,
                                                        "fa-file-o": !vehicle.rep_note
                                                      },
                                                      attrs: {
                                                        slot: "reference"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          $event.stopPropagation()
                                                          return _vm.openRepNoteModel(
                                                            vehicle
                                                          )
                                                        }
                                                      },
                                                      slot: "reference"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "image-vehicle" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getVehicleLink(vehicle.id)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToCar(vehicle)
                                        }
                                      }
                                    },
                                    [
                                      vehicle.front_image_url
                                        ? _c("img", {
                                            attrs: {
                                              src: vehicle.front_image_url,
                                              alt: "Front"
                                            }
                                          })
                                        : _vm._e()
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "model" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getVehicleLink(vehicle.id)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToCar(vehicle)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(vehicle.year) +
                                          " " +
                                          _vm._s(vehicle.make)
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(vehicle.model)
                                        }
                                      }),
                                      _vm._v(
                                        " /\n                                        "
                                      ),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(vehicle.grade)
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.hidePrices && _vm.priceField(vehicle)
                                  ? _c(
                                      "div",
                                      { staticClass: "price-container" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.priceField(vehicle)) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "infos" }, [
                                    _c("div", [
                                      _c("span", [_vm._v("Grade:")]),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "rating" }, [
                                        _vm._v(_vm._s(vehicle.condition))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "cc" }, [
                                      _c("span", { staticClass: "cc" }, [
                                        _vm._v(
                                          _vm._s(vehicle.engine_capacity) + "cc"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("span", { staticClass: "mileage" }, [
                                        _vm._v(_vm._s(vehicle.mileage) + "km")
                                      ])
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "details" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(vehicle.transmission) +
                                      " / " +
                                      _vm._s(
                                        _vm.convertEquipment(vehicle.equipment)
                                      ) +
                                      "\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "notes text-success",
                                  domProps: {
                                    innerHTML: _vm._s(vehicle.sales_note)
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "view-more" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "link arrow",
                                      attrs: {
                                        href: _vm.getVehicleLink(vehicle.id)
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.goToCar(vehicle)
                                        }
                                      }
                                    },
                                    [_vm._v("View more")]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    }),
                    _vm._v(" "),
                    _vm._l([1, 2, 3, 4, 5, 6, 7, 8], function(vehicle) {
                      return _c("div", {
                        staticClass: "single-result-search none"
                      })
                    })
                  ],
                  2
                )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "bottom-container-result d-flex justify-content-end flex-wrap"
            },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _vm.total > _vm.per_page
                    ? _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.total,
                          "per-page": _vm.per_page
                        },
                        model: {
                          value: _vm.current_page,
                          callback: function($$v) {
                            _vm.current_page = $$v
                          },
                          expression: "current_page"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("vehicle-stock-message", {
        ref: "vehicleStockMessage",
        on: { changed: _vm.onVehicleStockMessagesAdd }
      }),
      _vm._v(" "),
      _c("vehicle-stock-rep-note", {
        attrs: { vehicle: _vm.repNoteVehicle },
        on: { vehicleUpdated: function($event) {} },
        model: {
          value: _vm.repNoteModalOpen,
          callback: function($$v) {
            _vm.repNoteModalOpen = $$v
          },
          expression: "repNoteModalOpen"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e81f1992", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e81f1992","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/ListPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e81f1992","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/ListPage.vue
// module chunks = 0